export const ONE_PX_IN_REM = 1 / 16;
